<template>
  <div class="home-page">
    <!-- 导航栏 -->
    <header class="header">
      <div class="container header-inner">
        <img src="@/assets/gituLogo.png" alt="" class="logo">
        <!-- 锚点导航 -->
        <nav class="header-nav">
          <a href="#product" class="nav-item">解决方案</a>
          <a href="#cases" class="nav-item">案例展示</a>
          <a href="#about" class="nav-item">关于我们</a>
        </nav>
        <button class="header-btn" @click="goJump">登录注册</button>
      </div>
    </header>

    <!-- Hero Banner -->
    <section class="hero">
      <div class="heroBox">
        <img src="@/assets/Mask_group.png" alt="">
        <div class="container hero-inner">
          <div class="hero-text">
            <h1 class="hero-title">
              一张图生成专业<br />
              <span>商品套图</span>
            </h1>
            <p class="hero-desc">
              上传产品图片，AI 自动生成符合电商平台规范的美化商品套图
            </p>
            <button class="hero-btn" @click="goJump">立即体验 <img src="@/assets/Vector.png" alt=""> </button>
          </div>
        </div>
      </div>
    </section>

    <!-- 三步流程 -->
    <section class="steps" id="steps">
      <div class="container steps-inner">
        <h2 class="steps-title">
          简单三步，即刻出图<br />
          <small>操作无忧</small>
        </h2>
        <div class="steps-list">
          <div class="step-item">
            <img class="step-icon" src="@/assets/img1.png" alt="">
            <p class="step-no">第一步</p>
            <h3 class="step-title">上传产品图</h3>
            <p class="step-desc">导入图片或视频/模型</p>
          </div>
          <div class="step-item">
            <img class="step-icon" src="@/assets/img2.png" alt="">
            <p class="step-no">第二步</p>
            <h3 class="step-title">创作</h3>
            <p class="step-desc">AI 自动生成多种风格方案</p>
          </div>
          <div class="step-item">
            <img class="step-icon" src="@/assets/img3.png" alt="">
            <p class="step-no">第三步</p>
            <h3 class="step-title">一键生成</h3>
            <p class="step-desc">获得高清大图，直接使用</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 商品套图 -->
    <section class="product" id="product">
      <div class="container product-inner">
        <div class="product-text">
          <h2 class="section-title">
            商品 <span>套图</span>
          </h2>
          <p class="section-desc">
            不会 AI 提示词、没设计经验、没模特？<br />
            用 GituAI，快速获得高清美化套图！<br />
            上传一张产品图，一键生成多角度商品套图，兼容主流电商尺寸与平台。<br />
            支持产品尺寸与场景调整，适配 Amazon/Temu 等多平台。<br />
            小白也能做出高质量的套图，提升转化！
          </p>
          <button class="section-btn" @click="goJump">免费使用</button>
        </div>
        <div class="product-img">
          <div class="img-box">
            <img src="@/assets/Group_38.png" alt="">
          </div>
        </div>
      </div>
    </section>

    <!-- AI 视频 -->
    <section class="video">
      <div class="container video-inner">
        <div class="video-img">
          <div class="img-box"> <img src="@/assets/Group_39.png" alt=""></div>
        </div>
        <div class="video-text">
          <h2 class="section-title">
            AI <span>视频</span>
          </h2>
          <p class="section-desc">
            还在为拍摄视频找场景、不会剪辑烦恼？<br />
            用 GituAI 开启你的创作效率上卷！<br />
            上传一张商品图，无需更换场景，自动生成场景视频，突出商品卖点。<br />
            小白也能一键生成高质量的商品视频，轻松提高曝光！
          </p>
          <button class="section-btn" @click="goJump">免费使用</button>
        </div>
      </div>
    </section>

    <!-- 案例展示 锚点 cases -->
    <section class="cases" id="cases">
      <div class="container cases-inner">
        <h2 class="section-title cases-title">
          案例展示<br />
          <small>用GituAI 工具制作的优质商品场景套图案例</small>
        </h2>
        <div class="cases-grid">
          <div class="case-item">
            <div class="case-img">
              <img src="@/assets/Rectangle_24(1).jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img red-shoe">
              <img src="@/assets/Rectangle_24.jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img perfume">
              <img src="@/assets/Rectangle_25(1).jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img glasses">
              <img src="@/assets/Rectangle_25.jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img colorful-shoe">
              <img src="@/assets/Rectangle_26(2).png" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img skincare">
              <img src="@/assets/Rectangle_26.jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img watch">
              <img src="@/assets/Rectangle_27(2).jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img red-shoe-yellow">
              <img src="@/assets/Rectangle_27.jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img red-perfume">
              <img src="@/assets/Rectangle_28(1).jpg" alt="">
            </div>
          </div>
          <div class="case-item">
            <div class="case-img backpack">
              <img src="@/assets/Rectangle_28.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 为什么选择我们 锚点 solution -->
    <section class="features" id="solution">
      <div class="container features-inner">
        <h2 class="section-title features-title">
          为什么选择Gitu AI?<br />
          <small>聚合多项前沿AI生成技术，专为跨境电商而生，低成本快速打造专业级电商套图!</small>
        </h2>
        <div class="features-grid">
          <div class="feature-card">
            <img class="feature-icon" src="@/assets/Group_47.png" alt="">
            <h3>快速生成</h3>
            <p class="feature-desc">
              <span>上传产品图，1分钟拿到套图</span>
            </p>
          </div>
          <div class="feature-card">
            <img class="feature-icon" src="@/assets/Group_47(2).png" alt="">
            <h3>创作成本</h3>
            <p class="feature-desc">
              <span>无经验、低成本零沟通，一人高效上品</span>
            </p>
          </div>
          <div class="feature-card">
            <img class="feature-icon" src="@/assets/Group_47(4).png" alt="">
            <h3>风格一致性</h3>
            <p class="feature-desc">
              <span>套图场景丰富:围绕同一素材风格稳定</span>
            </p>
          </div>
          <div class="feature-card">
            <img class="feature-icon" src="@/assets/Group_47(1).png" alt="">
            <h3>批量处理</h3>
            <p class="feature-desc">
              <span>多任务并行提升用户出图效率</span>
            </p>
          </div>
          <div class="feature-card">
            <img class="feature-icon" src="@/assets/Group_47(3).png" alt="">
            <h3>高清输出</h3>
            <p class="feature-desc">
              <span>图片高清无水印快速批量下载</span>
            </p>
          </div>
          <div class="feature-card">
            <img class="feature-icon" src="@/assets/Group_52.png" alt="">
            <h3>图生视频</h3>
            <p class="feature-desc">
              <span>无需拍摄剪辑，轻松获取产品多角度展示视频</span>
            </p>
          </div>
        </div>
      </div>
      <div style="width: 100%; text-align: center; margin-top: 30px; display: flex; justify-content: center;">
        <button class="cases-btn" @click="goJump">开始你的第一张创作吧<img src="@/assets/Vector.png" alt=""> </button>
      </div>
    </section>

    <!-- 页脚 锚点 about -->
    <footer class="footer" id="about">
      <div class="container footer-inner">
        <div class="footer-left">
          <div class="footer-left-box">
            <img class="footer-logo" src="@/assets/gituLogo.png" alt="">
            <div class="footer-test">专业AI做图网站</div>
          </div>
          <div class="footer-links">
            <span>商品案例</span>
            <span>AI视频</span>
            <span>模特图</span>
            <span>生活相册</span>
            <span>生成尺寸图</span>
          </div>
        </div>
        <div class="footer-center">
          <div>
            <div class="footer-center-l">商务联系</div>
            <div class="footer-center-r">19070186426</div>
          </div>
          <div>
            <div class="footer-center-l">地址</div>
            <div class="footer-center-d">红谷滩莱蒙都会写字楼5A座1706</div>
          </div>
        </div>
        <div class="footer-right">
          <div class="qrcodes">
            <div class="qrcode">
              <img src="@/assets/Group_44.png" alt="">
              <div class="qrcode-test">联系官方客服</div>
            </div>
            <div class="qrcode">
              <img src="@/assets/Group_45.png" alt="">
              <div class="qrcode-test">关注服务号</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-d">
        © COPYRIGHT©2023 南昌途光信息科技有限公司 赣ICP备2023016578号-3
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <div v-show="showToTop" class="to-top-btn" @click="scrollToTop">
      ↑
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      showToTop: false
    };
  },
  mounted() {
     window.addEventListener("scroll", this.handleScroll);
  // 锚点平滑滚动（避开导航栏）
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const target = document.querySelector(targetId);
      if (target) {
        const headerHeight = 60; // 👈 你的导航栏高度是60px
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    goJump() {
      window.open('https://www.data.igitu.net/#/home', '_blank')
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.showToTop = true;
      } else {
        this.showToTop = false;
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped lang="scss">
/* 通用样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  margin: 0 auto;
  padding: 0 20px;
}

.home-page {
  font-family: "Microsoft YaHei", sans-serif;
}

/* 导航栏 */
.header {
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;

  .header-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;

    .logo {
      width: 130px;
    }

    .header-nav {
      display: flex;
      gap: 40px;

      .nav-item {
        color: #333;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s ease;

        &:hover {
          color: #ff9a16;
        }
      }
    }

    .header-btn {
      background: #ff9a16;
      color: #fff;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      cursor: pointer;
      transition: background 0.3s ease;
    }
  }
}

/* Hero Banner */
.hero {
  border-radius: 12px;
  padding-top: 52px;

  .heroBox {
    width: 100%;
    height: 94vh;
    max-height: 94vh;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .hero-inner {
    position: absolute;
    top: 38%;
    left: 14%;

    .hero-text {
      .hero-title {
        font-size: 46px;
        line-height: 1.4;
        margin-bottom: 20px;

        span {
          color: #ff9a16;
        }
      }

      .hero-desc {
        color: #666;
        margin-bottom: 30px;
        font-size: 16px;
      }

      .hero-btn {
        display: flex;
        background: #ff9a16;
        color: #fff;
        border: none;
        padding: 12px 24px;
        border-radius: 6px;
        font-size: 16px;
        cursor: pointer;
        transition: background 0.3s ease;
        align-items: center;

        img {
          width: 20px;
          margin-left: 6px;
        }
      }
    }
  }
}

/* 三步流程 */
.steps {
  padding: 60px 0;
  background: #fafafa;

  .steps-inner {
    .steps-title {
      text-align: center;
      font-size: 24px;
      margin-bottom: 40px;

      small {
        display: block;
        font-size: 14px;
        color: #ff9a16;
        margin-top: 8px;
      }
    }

    .steps-list {
      display: flex;
      justify-content: center;
      gap: 16%;
      flex-wrap: wrap;

      .step-item {
        width: 180px;
        text-align: center;

        .step-icon {
          width: 50px;
          height: 50px;
          font-size: 20px;
          border-radius: 8px;
          margin: 0 auto 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .step-no {
          font-size: 12px;
          color: #999;
          margin-bottom: 6px;
        }

        .step-title {
          font-size: 16px;
          margin-bottom: 6px;
        }

        .step-desc {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }
}

/* 商品套图 */
.product {
  padding: 47px 89px;

  .product-inner {
    display: flex;
    align-items: center;
    gap: 40px;

    .product-text,
    .product-img {
      flex: 1;
    }

    .section-title {
      font-size: 28px;
      margin-bottom: 20px;

      span {
        color: #ff9a16;
      }
    }

    .section-desc {
      color: #666;
      line-height: 1.8;
      margin-bottom: 30px;
    }

    .section-btn {
      background: #ff9a16;
      color: #fff;
      border: none;
      padding: 12px 24px;
      border-radius: 6px;
      cursor: pointer;
      transition: background 0.3s ease;
    }

    .img-box {
      width: 100%;
      aspect-ratio: 16 / 9;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
}

/* AI 视频 */
.video {
  padding: 47px 89px;
  background: #fafafa;

  .video-inner {
    display: flex;
    align-items: center;
    gap: 40px;

    .video-text,
    .video-img {
      flex: 1;
    }

    .section-title {
      font-size: 28px;
      margin-bottom: 20px;

      span {
        color: #ff9a16;
      }
    }

    .section-desc {
      color: #666;
      line-height: 1.8;
      margin-bottom: 30px;
    }

    .section-btn {
      background: #ff9a16;
      color: #fff;
      border: none;
      padding: 12px 24px;
      border-radius: 6px;
      cursor: pointer;
      transition: background 0.3s ease;
    }

    .img-box {
      width: 100%;
      aspect-ratio: 16 / 9;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }
}

/* 案例展示 */
.cases {
  padding: 47px 89px;
  background: #fff;

  .cases-inner {
    .section-title {
      text-align: center;

      &.cases-title {
        small {
          display: block;
          font-size: 12px;
          color: #ff9a16;
          margin-top: 8px;
          font-weight: normal;
        }
      }
    }

    .cases-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 16px;
      margin-top: 40px;

      .case-item {
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;

        .case-img {
          width: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            transition: transform 0.3s ease;
            display: block;
          }
        }

        &:hover .case-img img {
          transform: scale(1.05);
        }
      }
    }
  }
}

/* 为什么选择我们 */
.features {
  padding: 47px 89px;
  background: #fff;

  .features-inner {
    .section-title {
      text-align: center;

      &.features-title {
        small {
          display: block;
          font-size: 12px;
          color: #ff9a16;
          margin-top: 8px;
          font-weight: normal;
        }
      }
    }

    .features-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      margin-top: 40px;

      .feature-card {
        background: #fff;
        border: 1px solid #eee;
        border-radius: 8px;
        padding: 24px;

        .feature-icon {
          width: 40px;
          height: 40px;
          border-radius: 4px;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        h3 {
          font-size: 16px;
          margin-bottom: 12px;
        }

        .feature-desc {
          font-size: 12px;
          color: #666;
          line-height: 1.6;

          span {
            color: #ff9a16;
          }
        }
      }
    }
  }
}

/* 页脚 */
.footer {
  background: linear-gradient(135deg, #fff5e8 0%, #ffdfc4 100%);
  padding: 47px 89px;
  position: relative;

  .footer-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .footer-left {
      display: flex;
      align-items: flex-start;

      .footer-left-box {
        .footer-logo {
          width: 90px;
        }

        .footer-test {
          font-size: 11px;
          color: #666666;
          line-height: 23px;
        }
      }

      .footer-links {
        display: flex;
        gap: 16px;
        font-size: 14px;
        color: #333333;
        margin-left: 21px;
      }
    }

    .footer-center {
      .footer-center-l {
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        text-align: left;
      }

      .footer-center-r {
        font-size: 20px;
        color: #F98801;
        text-align: left;
        margin-bottom: 8px;
      }

      .footer-center-d {
        font-size: 16px;
        color: #333333;
        font-weight: 700;
        line-height: 20px;
        text-align: left;
      }
    }

    .footer-right {
      .qrcodes {
        display: flex;
        gap: 16px;

        .qrcode {
          width: 80px;
          height: 80px;
          background: #fff;
          border-radius: 4px;
          color: #666;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          .qrcode-test {
            width: 100%;
            text-align: center;
            font-size: 11px;
            color: #666666;
          }
        }
      }
    }
  }

  .footer-d {
    position: absolute;
    bottom: 2px;
    left: 39%;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
}

.cases-btn {
  display: flex;
  background: #ff9a16;
  color: #fff;
  border: none;
  padding: 8px 36px;
  border-radius: 42px;
  cursor: pointer;
  transition: background 0.3s ease;
  align-items: center;

  img {
    width: 17px;
    margin-left: 10px;
  }
}

/* 按钮悬浮加深 */
.header-btn:hover,
.hero-btn:hover,
.section-btn:hover,
.cases-btn:hover {
  background-color: #e68900 !important;
}

/* 返回顶部按钮 */
.to-top-btn {
  position: fixed;
  bottom: 80px;
  right: 30px;
  width: 32px;
  height: 47px;
  background: #ff9a16;
  color: #fff;
  border-radius: 12%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 999;

  &:hover {
    background: #e68900;
    transform: translateY(-3px);
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .header .header-inner {
    .header-nav {
      gap: 20px;
    }
  }

  .product-inner,
  .video-inner {
    flex-direction: column;
  }

  .hero-title {
    font-size: 28px;
  }

  .cases-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .footer-inner {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .footer-right {
    flex-direction: column;
    gap: 20px;
  }

  .to-top-btn {
    right: 20px;
    bottom: 60px;
    width: 40px;
    height: 40px;
  }

  .product,
  .video,
  .cases,
  .features,
  .footer {
    padding: 30px 20px;
  }
}
</style>